'use client';

import type { PropsWithChildren } from 'react';
// import { AnimatePresence, motion } from 'motion/react';
import { type Brands, type Themes, Theme, useSetBrand } from './Theme';
import { ScrollableContainer } from './LenisScroll';

export type PageWrapperProps = {
	className?: string;
	pageDefaultBrand?: Brands;
	pageDefaultTheme?: Themes;
};

export function PageWrapper(props: PropsWithChildren<PageWrapperProps>) {
	const setBrand = useSetBrand();
	const pageDefaultBrand = props.pageDefaultBrand ?? 'core';
	const pageDefaultTheme = props.pageDefaultTheme ?? 'dark';

	if (pageDefaultBrand !== 'core') {
		setBrand(pageDefaultBrand);
	}

	return (
		<Theme
			defaultPageBrand={pageDefaultBrand}
			defaultPageTheme={pageDefaultTheme}
			className={`page-wrapper ${props.className || ''} bg-background-primary`}
		>
			<ScrollableContainer>
				<div
					id='3D-HTML-TEXT'
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						pointerEvents: 'none',
						overflow: 'hidden',
						width: '100%',
						height: '100%',
					}}
				/>
				{props.children}
			</ScrollableContainer>
		</Theme>
	);
}

export function PageMain(props: PropsWithChildren) {
	// const pathname = 'path';
	// const onExitComplete = () => {
	// 	window.scrollTo({ top: 0 });
	// };

	// const initial = { y: '100vh', opacity: 1 };
	// const animate = { y: 0, opacity: 1 };
	// const exit = { y: 0, opacity: 0 };
	// const transition = { duration: 0.8, ease: [0, 0.7, 0.3, 1] };

	return (
		// <AnimatePresence initial={false} mode='popLayout' onExitComplete={onExitComplete}>
		<main
			// key={pathname}
			role='main'
			// id={`page-${pathname}`}
			// initial={initial}
			// animate={animate}
			// exit={exit}
			// transition={transition}
		>
			{props.children}
		</main>
		// </AnimatePresence>
	);
}
